/**
 * QUESTION-POLARITY.THUNK
 * Project assistant (AI) : the sense of the statements of a questionnaire (what an agreement means). The server remembers
 * the answer in the options of each question, so asking twice the same text costs nothing.
 * Silent : an error never shows a message, the assistant simply has nothing to suggest.
 */

import { createAsyncThunk } from "@reduxjs/toolkit"
import { fetchBackend } from "@/core/apis/backend"

export interface QuestionPolarityResult {
  id: string
  polarity: "positive" | "negative" | "neutral"
  confidence: number
  cached: boolean
}

export const fetchQuestionPolarity = createAsyncThunk(
  "questionPolarity/fetch",
  async ({ questions, language }: { questions: { id: string; text: string }[]; language: string }) => {
    const res = await fetchBackend({
      url: "/project-assistant/polarity",
      method: "POST",
      data: { questions, language },
      timeout: 60000,
      isSilent: true
    })
    return res.error || !Array.isArray(res.results) ? [] : (res.results as QuestionPolarityResult[])
  }
)
